import { render } from "./I_LeftPart.vue?vue&type=template&id=928c4c06"
import script from "./I_LeftPart.vue?vue&type=script&lang=js"
export * from "./I_LeftPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__